import { useState } from "react";
import { Typography, Box, Link, Switch } from "@mui/material";
import { LoadingError, LoadingPaper } from "../../LoadingComponents";
import {
  renderEUDateTimeLong,
  prettify,
  renderEUDateTime,
} from "../../../utils/utils";
import { useGetUserById } from "../useHandlingQueries";
import { EditableInputDisplay } from "../../EditableComponents";

function ViewUser({ editMode, updateEditState, user_id }) {
  // === web service queries/mutations ===
  const userQuery = useGetUserById(user_id);

  return (
    <>
      {userQuery.isLoading ? (
        <LoadingPaper />
      ) : userQuery.isError ? (
        <LoadingError error={userQuery.error} />
      ) : (
        userQuery.data !== undefined && (
          <Box
            sx={{
              display: "grid",
              margin: "auto",
              gridTemplateColumns: "1fr",
              width: "100%",
            }}
          >
            <Box sx={{ margin: "10px" }}>
              <EditableInputDisplay
                id={"email"}
                label={"Email:"}
                initialValue={userQuery.data.email}
                setEditMode={editMode}
                inputMode={"text"}
                setParentValue={updateEditState}
              />
              <EditableInputDisplay
                id={"mobile"}
                label={"Cellulare:"}
                initialValue={userQuery.data.mobile}
                setEditMode={editMode}
                inputMode={"text"}
                setParentValue={updateEditState}
              />

              <Typography>
                <strong>Tipo di utente:</strong> {userQuery.data.user_type}
              </Typography>
              <Typography>
                <strong>Data creazione:</strong>{" "}
                {renderEUDateTime(userQuery.data.enroll_date)}
              </Typography>
              <Typography>
                <strong>Data ultimo accesso:</strong>{" "}
                {renderEUDateTime(userQuery.data.last_login)}
              </Typography>
              <Typography>
                <strong>ID Organizzazione:</strong> {userQuery.data.org_id}
              </Typography>
              {/* <EditableInputDisplay
                // FORSE ORG_NAME ^^^?
                id={"org_id"}
                label={"Organizzazione (ID):"}
                initialValue={userQuery.data.org_id}
                setEditMode={editMode}
                inputMode={"select"}
                selectType={"organizations"}
                selectQueryKey={["organizations"]}
                setParentValue={updateEditState}
              /> */}
              {/*                   
              <Typography>
                {userQuery.data.org_name === null ? (
                  ""
                ) : (
                  <>
                    <strong>Nome organizzazione:</strong>{" "}
                    {userQuery.data.org_name}
                  </>
                )} 
              </Typography>*/}
            </Box>
          </Box>
        )
      )}
    </>
  );
}

export default ViewUser;
